import {Component, Input, OnInit} from '@angular/core';
import {DashboardConfigurationModel} from '../api/dashboard-configuration-model';
import {UserInfoService} from '../api/user-info.service';
import {UserInfoModel} from '../api/user-info-model';
import {Router} from "@angular/router";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
    public hideUtillities = true;


  constructor(private userInfoService: UserInfoService,
              private router: Router) {  }

  @Input()
  public dashboards: DashboardConfigurationModel[] = [];
  user: UserInfoModel;

  async ngOnInit() {
    this.user = await this.userInfoService.get().toPromise();
  }

  openDashboard(d: DashboardConfigurationModel) {
    console.log(d);
    this.router.navigate(['dashboard', d.dashboardName], {queryParams: {d: new Date().getTime()}});
    }

    toggleHideUtillities() {
        this.hideUtillities = !this.hideUtillities;
        console.log("this.hideUtillities=" + this.hideUtillities);
    }
}
